import { observer } from 'mobx-react';
import React, { useMemo } from 'react';
import { IValidation } from '~/types/main';
import t360IntegrationStore from '~/view/screens/SettingsScreen/store/t360IntegrationStore';
import { localeStore } from '~/mobx/localesStore';
import Picker from '~/view/components/Controls/Pickers/Picker/Picker';
import { IMenuSet } from '~/types/integrations';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';

interface IProps {
  integrationId: number;
  disabled?: boolean;
  wrapperClassName?: string;
}

const T360MenuSet: React.FC<IProps> = observer((props: IProps) => {
  const integrationSettingsTemp = useMemo(
    () => t360IntegrationStore.integrationsSettingsTemp[props.integrationId],
    [t360IntegrationStore.integrationsSettingsTemp]
  );

  const selectedMenuGroupsOptionsList = useMemo(() => {
    return t360IntegrationStore.integrationsSettings?.menu_sets
      .filter((menuSet: IMenuSet) => integrationSettingsTemp.settings.menu_group === menuSet.id)
      .map(
        (menuSet: IMenuSet): IPickerOption => ({
          label: menuSet.category,
          value: menuSet.id,
        })
      );
  }, [t360IntegrationStore.integrationsSettings?.menu_sets, t360IntegrationStore.integrationsSettingsTemp]);

  const selectMenuGroup = (menuGroupOptions: IPickerOption[]) => {
    const settings = JSON.parse(JSON.stringify(integrationSettingsTemp));
    settings.settings.menu_group = menuGroupOptions.map((menuGroupOption: IPickerOption) => menuGroupOption.value)[0] ?? null;
    t360IntegrationStore.updateIntegrationSettingsTemp(props.integrationId, settings);
  };

  const menuIdValidation = useMemo<IValidation>(() => {
    const errors = t360IntegrationStore.errors[props.integrationId] ?? {};

    const isValid = errors.menu_group === undefined;
    let errorText: string = '';
    if (!isValid) {
      errorText = errors.menu_group instanceof Array ? errors.menu_group[0] : String(errors.menu_group);
    }

    return {
      isValid,
      errorText,
    };
  }, [t360IntegrationStore.errors, t360IntegrationStore.errors[props.integrationId]?.menu_group]);

  return (
    <div className={`d-flex flex-column ${props.wrapperClassName || ''}`}>
      <h3 className="family-bold text-size-18 mb-2">{localeStore.t('menu_group')}</h3>
      <Picker
        className="w-100"
        options={t360IntegrationStore.menuGroupsOptions}
        selectedOptions={selectedMenuGroupsOptionsList}
        onSelect={selectMenuGroup}
        loading={t360IntegrationStore.isOnLoading}
        disabled={props.disabled}
        listPlacement="bottom"
        numberVisibleOptionsInDropdown={5}
        viewedSize="normal"
        hideResetIcon
        validation={menuIdValidation}
      />
    </div>
  );
});

export default T360MenuSet;
